"use client";

import { DatadogAppRouter as DatadogAppRouterPlugin } from "@datadog/browser-rum-nextjs";
import { isDatadogRumConfigured } from "@/lib/datadog/config";

export function DatadogAppRouter() {
  if (!isDatadogRumConfigured()) {
    return null;
  }

  return <DatadogAppRouterPlugin />;
}
